import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles(() => ({
//   alertBox: {
//     display: 'flex',
//     alignItems: 'center',        // vertical centering
//     justifyContent: 'flex-start',// left-align horizontally
//     padding: '12px 16px',
//     borderRadius: '8px',
//     marginBottom: '16px',
//     textAlign: 'left',           // ensure text is left-aligned
//   },
alertBox: {
    display: 'flex',            // Stack icon and text horizontally
    alignItems: 'center',       // Vertically center the icon and text
    padding: '12px 16px',       // Inner spacing
    borderRadius: 8,
    marginTop: '16px',
    width: 'fit-content',       // 👈 Only take width of content
    maxWidth: '100%',           // Prevent overflow
  },
  icon: {
    marginRight: '8px',          // space between icon and text
    fontSize: '1.25rem',         // adjust icon size if needed
  },
  success: {
    backgroundColor: 'rgba(112, 173, 71, 30%)',
    // opacity: '20%'
    
  },
  warning: {
    backgroundColor: 'rgba(244, 177, 131, 30%)',
    // opacity: '20%'
  },
}));

const AlignmentAlerts = ({data}) => {
  const classes = useStyles();


  return (
    <Box style={{marginBottom: '2.5rem'}}>
      {/* Bad Alignment */}
      {data.map((item, index) => (
  <Box key={index} className={`${classes.alertBox} ${classes[item.status]}`}>
    {item.status === 'success' ? (
      <CheckCircleOutlineIcon className={classes.icon} style={{color: 'green'}}/>
    ) : (
      <ErrorOutlineIcon className={classes.icon} style={{color: '#c65911'}}/>
    )}
    <Typography variant="body2">{item.text}</Typography>
  </Box>
))}

    </Box>
  );
};

export default AlignmentAlerts;